import { ProjectUnscheduledStopsBulkUpdatedDtoModelType } from '../../models/ProjectUnscheduledStopsBulkUpdatedDtoModel';
import getAppRoot from '../../utils/getAppRoot';
import { UnscheduledVisitDetailQuery } from '../../queries/visits/UnscheduledVisitQueries';

export default ({ store, updatedVisitIds }: ProjectUnscheduledStopsBulkUpdatedDtoModelType) => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;
  const uuids = updatedVisitIds?.filter(v => v.uuid).map((v) => v.uuid);

  if (projectId && uuids?.length) {
    rootStore.model.queryVisitsByEventUuids({
      projectId,
      uuids,
    }, UnscheduledVisitDetailQuery);
  }
};
